export const CERTIFICATIONS = {
  ATTRS_NAME: 'breeder_profile_certifications_attributes',
  INPUT_NAME: 'breeder_certification_attributes',
  INPUT_NAME_ID: 'breeder_certification_id'
};

export const CLUBS = {
  NATIONAL_ATTRS_NAME: 'national_breeder_profile_clubs_attributes',
  LOCAL_ATTRS_NAME: 'local_breeder_profile_clubs_attributes',
  INPUT_NAME: 'breeder_club_attributes',
  INPUT_NAME_ID: 'breeder_club_id'
};

export const PAYOUT_SUCCESS_TITLE = 'All set!';
export const PAYOUT_SUCCESS_COPY = `
  Thanks for adding your payout method. Payments made to you through
  Good Dog will be paid out directly to your payout method.
`;

export const DOB_FIELD_NAME =
  'breeder_profile.billing_profile_attributes.date_of_birth';

export const SNOOZED_REASONS = {
  BREAK: 'Taking a break',
  TOO_MANY_APPLICATIONS: 'Too many applications',
  RETIRED: 'Retired or no longer breeding breed',
  OTHER: 'Other'
};

const BUYER_APP_BACKGROUND_QUESTIONS = [
  'First and last name',
  'Email address',
  'Phone number',
  'City and state',
  'Number of children and ages',
  'Do you currently have any pets?',
  'Have you owned a dog before?',
  'Describe your lifestyle, family, and any other details you’d like to share ',
  'What type of home do you live in (e.g., house, apartment)?',
  'Will you be the primary caretaker of the puppy? If no, who will be?',
  'Photo of you or your family (optional)'
];

const BUYER_APP_QUESTIONS_PREFERENCES = [
  'Puppy preference',
  'Gender preference',
  'Color preference',
  'Size preference',
  'Which pickup or drop-off options are you interested in? (These options are based on the puppy transportation options you’ve listed on your Good Dog profile) '
];

export const BUYER_APP_QUESTIONS_ORDER = [
  ['Background questions', BUYER_APP_BACKGROUND_QUESTIONS],
  ['Puppy preference questions', BUYER_APP_QUESTIONS_PREFERENCES]
];

export const BREEDER_REFUND_POLICY = {
  NON_REFUNDABLE: 'non-refundable',
  REFUNDABLE: 'refundable',
  OTHER: 'other'
};

export const SIGNATURE_REQUEST_STATUSES = {
  PENDING: 'pending',
  PENDING_CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  DECLINED: 'declined',
  CANCELLED: 'cancelled'
};
